import { MessageType } from 'app/contexts/notification/notification.reducer'
import React from 'react'

type NotificationContextType = {
  onOpen: (title: string, message: string, type: MessageType) => void
  onClose: () => void
}
export const NotificationContext = React.createContext<NotificationContextType>(
  {
    onOpen: () => null,
    onClose: () => null,
  }
)
